import { HttpClient } from '@angular/common/http';
import { Inject, inject, Injectable } from '@angular/core';
import { EnvConfig, Environment } from '@doc/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiUrls } from '../backoffice-urls';



@Injectable({
  providedIn: 'root'
})
export class QuestinoryService {

  private http = inject(HttpClient);
  private apiUrl: string;
  private baseUrl: string;

  sendQuestionData = new BehaviorSubject<any>(null);

  constructor(
    @Inject(EnvConfig) private config: Environment,
  ) {

    this.baseUrl = this.config.mockUrl;
    this.apiUrl = this.config.apiUrl;
  }

  sendQuestionDataObject(data: any) {
    this.sendQuestionData.next(data);
  }
  reaciveQuestionData(): Observable<any> {
    return this.sendQuestionData.asObservable();
  }

  saveFile(payload: FormData): Observable<any> {
    const url = this.apiUrl + ApiUrls.saveFile;
    return this.http.post(url, payload);
  }

  getDetailsByLookupId() {
    const url = this.apiUrl + ApiUrls.GetDrawingTypesLookUp;
    return this.http.get(url);
  }

  getQuestionaryList(body: any) {
    const url = this.apiUrl + ApiUrls.QuestionaryUrls.GET;
    return this.http.post(url, body);
  }

  getQuestionnaireDetails(questionaryId: any) {
    const url = this.apiUrl + ApiUrls.QuestionaryUrls.getQuestionnaireDetails + questionaryId;
    return this.http.get(url);
  }

  getQuestionaryById(val: any) {
    const url = this.apiUrl + ApiUrls.QuestionaryUrls.GET_BYID;
    return this.http.post(url, val);
  }

  createCategoryAndQuestionary(body: any) {
    const url = this.apiUrl + ApiUrls.QuestionaryUrls.CREATE;
    return this.http.post(url, body);
  }

  editQuestionary(id: any, body: any) {
    const url = this.apiUrl + ApiUrls.QuestionaryUrls.UPDATE + id;
    return this.http.post(url, body);
  }

  deleteQuestionary(id: any) {
    const url = this.apiUrl + ApiUrls.QuestionaryUrls.DELETE + id;
    return this.http.get(url);
  }

  createQuestion(data: any) {
    const url = this.apiUrl + ApiUrls.QuestionUrls.CREATE;
    return this.http.post(url, data);
  }

  editQuestion(id: any, data: any) {
    const url = this.apiUrl + ApiUrls.QuestionUrls.UPDATE + id;
    return this.http.post(url, data);
  }

  deleteQuestion(id: any) {
    const url = this.apiUrl + ApiUrls.QuestionUrls.DELETE + id;
    return this.http.get(url);
  }
}
